import {
  BathFittingCategory,
  BathFittingSubCategory,
} from "./bathFittingsTypes";

export const bathFittingCategories: BathFittingCategory[] = [
  {
    id: 1,
    name: "Bathroom Shower Sets",
    description:
      "Complete shower solutions with rain showers, hand showers, and thermostatic controls for luxury bathing experiences.",
    keyCharacteristics: [
      "Rain shower head included",
      "Hand shower with hose",
      "Thermostatic mixing valve",
      "Multiple spray patterns",
    ],
    commonMaterials: [
      "Stainless steel shower heads",
      "Brass thermostatic valves",
      "Chrome plated components",
      "Flexible stainless steel hoses",
    ],
    primaryUse: [
      "Master bathroom showers",
      "Guest bathroom installations",
      "Luxury spa bathrooms",
      "Hotel bathroom suites",
      "Modern shower enclosures",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Rain shower set
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Complete shower system
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Luxury shower head
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Hand shower detail
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Thermostatic control
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Shower rail system
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Modern installation
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Complete setup
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Steel", "Matte Black", "Rose Gold"],
    warranty: "10 years on thermostatic valve, 5 years on accessories",
    specifications: {
      material: "Stainless steel and brass construction",
      sizes: [
        "Standard shower set",
        "Luxury rain shower system",
        "Compact shower kit",
      ],
      finish: ["Chrome", "Brushed Steel", "Matte Black", "Rose Gold"],
      waterEfficiency: "Water saving technology, 8-12 LPM flow rate",
      installation: "Wall-mounted with concealed or exposed valve options",
      maintenance: "Monthly cleaning of shower heads, annual valve service",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation:
          "Luxury rain shower set with thermostatic control for comfort",
        keyChecks: [
          "Water pressure adequacy",
          "Wall structure strength",
          "Plumbing access for installation",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Standard shower set with reliable temperature control",
        keyChecks: [
          "Easy operation for guests",
          "Reliable thermostatic function",
          "Low maintenance requirements",
        ],
      },
      {
        location: "Spa Bathroom",
        recommendation:
          "Premium materials with multiple spray options for luxury",
        keyChecks: [
          "Luxury finish coordination",
          "Multiple outlet capability",
          "Professional installation required",
        ],
      },
      {
        location: "Family Bathroom",
        recommendation: "Safety-focused set with anti-scald protection",
        keyChecks: [
          "Child-safe temperature controls",
          "Easy maintenance access",
          "Durable construction for frequent use",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Bathtub Faucets & Spouts",
    description:
      "Elegant bathtub fillers and spouts designed for luxury soaking with high flow rates and sophisticated styling.",
    keyCharacteristics: [
      "High flow rate for quick filling",
      "Elegant waterfall design",
      "Precise temperature control",
      "Wall or deck mount options",
    ],
    commonMaterials: [
      "Solid brass construction",
      "Premium chrome plating",
      "Stainless steel internals",
      "Ceramic disc valves",
    ],
    primaryUse: [
      "Freestanding bathtubs",
      "Built-in luxury tubs",
      "Spa bathtub installations",
      "Hotel suite bathrooms",
      "Master bathroom features",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Bathtub faucet
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Luxury spout
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&h=600&fit=crop", // Waterfall design
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Floor-mounted filler
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Wall-mounted spout
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Modern design
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Luxury installation
      "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop", // Complete setup
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Gold", "Matte Black", "Copper"],
    warranty: "7 years comprehensive warranty",
    specifications: {
      material: "High-grade brass with premium plating",
      sizes: [
        "Standard bathtub faucet",
        "Floor-mounted tub filler",
        "Wall-mounted waterfall spout",
      ],
      finish: ["Chrome", "Brushed Gold", "Matte Black", "Copper"],
      waterEfficiency: "High flow rate 20-30 LPM for quick filling",
      installation: "Wall-mounted, deck-mounted, or floor-standing options",
      maintenance: "Regular cleaning and annual valve inspection",
    },
    useCases: [
      {
        location: "Luxury Master Suite",
        recommendation:
          "Floor-mounted filler with waterfall spout for dramatic effect",
        keyChecks: [
          "Bathtub positioning and style",
          "Floor structure for mounting",
          "Plumbing access and routing",
        ],
      },
      {
        location: "Spa Bathroom",
        recommendation:
          "Wall-mounted spout with concealed controls for clean aesthetics",
        keyChecks: [
          "Wall structure and support",
          "Concealed plumbing requirements",
          "Aesthetic integration with tiles",
        ],
      },
      {
        location: "Hotel Suite Bathroom",
        recommendation:
          "Premium finish with exceptional flow rate and durability",
        keyChecks: [
          "Commercial-grade construction",
          "Guest experience enhancement",
          "Easy maintenance access",
        ],
      },
      {
        location: "Contemporary Bathroom",
        recommendation:
          "Modern design with minimalist controls and sleek lines",
        keyChecks: [
          "Design coordination with fixtures",
          "Space optimization",
          "Contemporary finish options",
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Towel Warmers & Radiators",
    description:
      "Electric and hydronic towel warmers for comfort and luxury, available in various sizes and finishes.",
    keyCharacteristics: [
      "Electric or hydronic heating",
      "Multiple size options",
      "Energy efficient operation",
      "Designer radiator styles",
    ],
    commonMaterials: [
      "Stainless steel construction",
      "Chrome plated steel",
      "Aluminum alloy options",
      "Powder coated finishes",
    ],
    primaryUse: [
      "Master bathroom luxury",
      "Guest bathroom comfort",
      "Spa and wellness areas",
      "Hotel bathroom amenities",
      "Cold climate installations",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Towel warmer
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Electric radiator
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Modern design
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Wall installation
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Designer style
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Luxury finish
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Contemporary model
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Complete installation
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Chrome", "Brushed Steel", "Matte Black", "White"],
    warranty: "5 years on heating elements, 3 years on controls",
    specifications: {
      material: "Stainless steel with various finish options",
      sizes: ["Compact 600x400mm", "Standard 800x500mm", "Large 1200x600mm"],
      finish: ["Chrome", "Brushed Steel", "Matte Black", "White"],
      waterEfficiency: "Energy efficient heating, programmable controls",
      installation: "Wall-mounted with electrical or plumbing connections",
      maintenance: "Annual inspection, filter cleaning for hydronic models",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation: "Large luxury towel warmer with programmable controls",
        keyChecks: [
          "Wall space and mounting capability",
          "Electrical or plumbing access",
          "Energy efficiency requirements",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Compact electric model with simple controls",
        keyChecks: [
          "Available wall space",
          "Electrical connection proximity",
          "Guest-friendly operation",
        ],
      },
      {
        location: "Spa Bathroom",
        recommendation:
          "Designer radiator with premium finish and zone controls",
        keyChecks: [
          "Aesthetic integration with design",
          "Zone heating capability",
          "Professional installation required",
        ],
      },
      {
        location: "Cold Climate Home",
        recommendation: "High-output hydronic model for maximum warmth",
        keyChecks: [
          "Central heating system compatibility",
          "Insulation and heat loss assessment",
          "Professional hydronic installation",
        ],
      },
    ],
  },
  {
    id: 4,
    name: "Bathroom Lighting Systems",
    description:
      "LED lighting solutions for bathrooms including vanity lights, mirror lighting, and ambient illumination.",
    keyCharacteristics: [
      "LED energy efficiency",
      "IP44 water resistance rating",
      "Dimmable controls",
      "Various color temperatures",
    ],
    commonMaterials: [
      "Aluminum housing",
      "Tempered glass diffusers",
      "Stainless steel fixtures",
      "Polycarbonate covers",
    ],
    primaryUse: [
      "Vanity mirror illumination",
      "Shower area lighting",
      "Ambient bathroom lighting",
      "Accent lighting features",
      "Task lighting zones",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // LED vanity light
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Mirror lighting
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Ambient lighting
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Modern fixtures
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Ceiling lights
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Designer lighting
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Wall sconces
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Complete system
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Brushed Chrome", "Matte Black", "White", "Brushed Nickel"],
    warranty: "5 years on LED modules, 2 years on controls",
    specifications: {
      material: "Aluminum and stainless steel construction",
      sizes: [
        "Compact vanity light 300mm",
        "Standard mirror light 600mm",
        "Large vanity bar 900mm",
      ],
      finish: ["Brushed Chrome", "Matte Black", "White", "Brushed Nickel"],
      waterEfficiency: "LED technology, 15-25W power consumption",
      installation: "Wall or ceiling mount with electrical connections",
      maintenance: "Dust cleaning, LED modules last 25,000+ hours",
    },
    useCases: [
      {
        location: "Master Bathroom Vanity",
        recommendation:
          "Large vanity bar with dimmable LED for optimal grooming light",
        keyChecks: [
          "Mirror size and positioning",
          "Electrical wiring access",
          "Dimmer switch compatibility",
        ],
      },
      {
        location: "Guest Powder Room",
        recommendation: "Compact vanity light with warm white LED",
        keyChecks: [
          "Space constraints",
          "Adequate illumination for tasks",
          "Simple switch operation",
        ],
      },
      {
        location: "Spa Bathroom",
        recommendation:
          "Multiple lighting zones with ambient and task lighting",
        keyChecks: [
          "Zone control requirements",
          "Professional lighting design",
          "Integration with other systems",
        ],
      },
      {
        location: "Family Bathroom",
        recommendation: "Bright, even lighting for multiple users and safety",
        keyChecks: [
          "Even light distribution",
          "Safety and visibility",
          "Easy maintenance access",
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Bathroom Ventilation Systems",
    description:
      "Exhaust fans and ventilation solutions to maintain air quality and prevent moisture buildup in bathrooms.",
    keyCharacteristics: [
      "Quiet operation technology",
      "High CFM air movement",
      "Energy star efficiency",
      "Humidity sensing options",
    ],
    commonMaterials: [
      "Galvanized steel housing",
      "Plastic or metal grilles",
      "Energy efficient motors",
      "Backdraft dampers",
    ],
    primaryUse: [
      "Bathroom moisture control",
      "Air quality improvement",
      "Mold prevention",
      "Building code compliance",
      "Comfort enhancement",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Exhaust fan
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Ceiling ventilation
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Modern grille
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Installation view
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Ventilation system
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Humidity sensor
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Quiet operation
      "https://images.unsplash.com/photo-1574269269401-859094eee3a5?w=800&h=600&fit=crop", // Complete system
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["White", "Brushed Nickel", "Oil Rubbed Bronze"],
    warranty: "3 years on motor, 1 year on controls",
    specifications: {
      material: "Galvanized steel with corrosion-resistant coating",
      sizes: ["80 CFM compact", "110 CFM standard", "150 CFM high-capacity"],
      finish: ["White", "Brushed Nickel", "Oil Rubbed Bronze"],
      waterEfficiency: "Energy Star certified, low power consumption",
      installation: "Ceiling or wall mount with ductwork connections",
      maintenance: "Annual cleaning of grille and housing",
    },
    useCases: [
      {
        location: "Master Bathroom",
        recommendation:
          "High-capacity quiet fan with humidity sensing controls",
        keyChecks: [
          "CFM requirements for room size",
          "Ductwork routing capability",
          "Humidity sensor placement",
        ],
      },
      {
        location: "Guest Bathroom",
        recommendation: "Standard CFM fan with timer switch control",
        keyChecks: [
          "Adequate ventilation for space",
          "Timer switch installation",
          "Noise level considerations",
        ],
      },
      {
        location: "Powder Room",
        recommendation: "Compact fan with motion sensor activation",
        keyChecks: [
          "Space constraints",
          "Motion sensor compatibility",
          "Minimal noise requirements",
        ],
      },
      {
        location: "Steam Shower",
        recommendation: "High-capacity exhaust with steam-rated components",
        keyChecks: [
          "Steam environment compatibility",
          "High CFM requirements",
          "Professional installation needed",
        ],
      },
    ],
  },
  {
    id: 6,
    name: "Bath Safety & Accessibility",
    description:
      "Safety grab bars, shower seats, and accessibility features for secure and comfortable bathroom use.",
    keyCharacteristics: [
      "ADA compliant designs",
      "High weight capacity",
      "Non-slip surfaces",
      "Corrosion resistant materials",
    ],
    commonMaterials: [
      "Stainless steel construction",
      "Aluminum alloy components",
      "Non-slip rubber grips",
      "Powder coated finishes",
    ],
    primaryUse: [
      "Elderly assistance",
      "Disability accessibility",
      "Child safety measures",
      "General bathroom safety",
      "Therapeutic applications",
    ],
    image360: "/api/placeholder/800/600",
    images360: [
      "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop", // Grab bars
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&h=600&fit=crop", // Shower seat
      "https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800&h=600&fit=crop", // Safety rail
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800&h=600&fit=crop", // Accessibility features
      "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&h=600&fit=crop", // Non-slip surface
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop", // Support system
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop", // Installation view
      "https://images.unsplash.com/photo-1571736772567-3aa763ff559a?w=800&h=600&fit=crop", // Complete safety setup
    ],
    thumbnails: [
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
      "/api/placeholder/200/200",
    ],
    finishOptions: ["Brushed Stainless Steel", "White Powder Coat", "Chrome"],
    warranty: "Lifetime warranty on structural components",
    specifications: {
      material: "Stainless steel with anti-microbial coating",
      sizes: [
        "12-inch grab bar",
        "18-inch grab bar",
        "24-inch grab bar",
        "Fold-down shower seat",
      ],
      finish: ["Brushed Stainless Steel", "White Powder Coat", "Chrome"],
      waterEfficiency: "N/A - Safety and accessibility focused",
      installation: "Wall-mounted with structural backing required",
      maintenance: "Regular cleaning with mild disinfectant",
    },
    useCases: [
      {
        location: "Elderly Care Bathroom",
        recommendation:
          "Multiple grab bars with shower seat for comprehensive safety",
        keyChecks: [
          "Wall structure and backing",
          "ADA compliance requirements",
          "User mobility assessment",
        ],
      },
      {
        location: "Accessible Shower",
        recommendation: "Fold-down seat with strategically placed grab bars",
        keyChecks: [
          "Shower layout optimization",
          "Weight capacity requirements",
          "Professional installation",
        ],
      },
      {
        location: "Family Bathroom",
        recommendation: "Discreet grab bars that blend with design",
        keyChecks: [
          "Aesthetic integration",
          "Future accessibility planning",
          "Child safety considerations",
        ],
      },
      {
        location: "Therapeutic Bathroom",
        recommendation: "Comprehensive safety system with specialized features",
        keyChecks: [
          "Therapeutic requirements",
          "Medical equipment compatibility",
          "Caregiver accessibility",
        ],
      },
    ],
  },
];

export const bathFittingSubCategories: BathFittingSubCategory[] = [
  {
    id: 1,
    categoryId: 1,
    name: "Luxury Rain Shower Set",
    description:
      "Premium rain shower with thermostatic control and hand shower",
    image: "/api/placeholder/300/200",
    features: [
      "8-inch rain shower head",
      "Thermostatic mixing valve",
      "Hand shower with hose",
      "Chrome finish",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹15,000 - ₹35,000",
    availability: "In Stock",
  },
  {
    id: 2,
    categoryId: 1,
    name: "Standard Shower Set",
    description: "Complete shower solution with reliable performance",
    image: "/api/placeholder/300/200",
    features: [
      "Standard shower head",
      "Single lever control",
      "Hand shower included",
      "5-year warranty",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹8,000 - ₹18,000",
    availability: "In Stock",
  },
  {
    id: 3,
    categoryId: 2,
    name: "Waterfall Bathtub Spout",
    description: "Elegant waterfall design for luxury bathtub filling",
    image: "/api/placeholder/300/200",
    features: [
      "Waterfall design",
      "High flow rate",
      "Wall-mounted",
      "Premium finish",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹12,000 - ₹28,000",
    availability: "In Stock",
  },
  {
    id: 4,
    categoryId: 3,
    name: "Electric Towel Warmer",
    description: "Energy-efficient electric towel warming radiator",
    image: "/api/placeholder/300/200",
    features: [
      "Electric heating",
      "Programmable timer",
      "Chrome finish",
      "Energy efficient",
    ],
    image360: "/api/placeholder/800/600",
    price: "₹8,000 - ₹15,000",
    availability: "In Stock",
  },
];
